import { Color } from '@ionic/core';

import { IconSvg } from '../IconSvg';

import { MessageOrigin } from './Message.types';

export const BOX_COLOR_MAPPING: Partial<Record<MessageOrigin, Color>> = {
  me: 'medium',
};

export const AVATAR_COLOR_MAPPING: Record<MessageOrigin, Color> = {
  companion: 'tertiary',
  me: 'medium',
};

export const DEFAULT_AVATAR = <IconSvg name="avatar" />;
